import React, { useEffect, useContext, useRef } from 'react';
import { ReactP5Wrapper } from "react-p5-wrapper";
import { SocketContext } from '../components/SocketContext';
import ColorInput from './ColorInput.js'
import StyleSelector from './StyleSelector.js'

let color = "#000000"
let strokeWeight = 3;
let p5 = undefined;
let p5width = 700; let p5height = 500;
let isFilling = false;
let inFillMode = false;
let isDrawingLine = false;
let undoStack = [];
const MAX_UNDO = 5;


function sketch(p, socket) {
    console.log('Sketch');
    let canvas; // Declare canvas at the top of the sketch function
    p5 = p;

    p.setup = function () {
        canvas = p.createCanvas(700, 500); // Assign the p5 canvas to the variable 
        p.pixelDensity(1);
        p.noFill();
        // p.noSmooth();
        p.background(255);
    };

    function sendFillEvent(mouseX, mouseY, color, sockettouse) {
        console.log('Sending fill event');
        sockettouse.emit('fill', { x: Math.round(mouseX), y: Math.round(mouseY), color: color });
    }

    function sendUndoEvent(sockettouse) {
        console.log('Sending undo event');
        sockettouse.emit('undo');
    }

    function startFill(p) {
        if (!isFilling) {
            p.saveState();
            isFilling = true;
            let mx = Math.round(p.mouseX); let my = Math.round(p.mouseY);
            socket.emit('fill', { x: mx, y: my, color: color });
            floodFill({ x: mx, y: my }, color);
            setTimeout(() => { isFilling = false; }, 2000);
        }
    }

    p.keyPressed = function () {
        if (p.key === ' ') {
            startFill();
        }

        if (p.key === 'u') {
            p.undo();
        }
    }

    //todo replace the draw metod when we switch to fill mode so we can keep it small.
    p.draw = function () {
        if (p.mouseIsPressed) {

            if (inFillMode) {
                startFill(p);
                return;
            }

            if (!isDrawingLine) {
                isDrawingLine = true;
                p.saveState();
                p.stroke(color);
                p.strokeWeight(strokeWeight);
                isDrawingLine = true;
            }

            
            const { mouseX, mouseY, pmouseX, pmouseY } = p;
            socket.emit('drawing', {
                x: mouseX,
                y: mouseY,
                px: pmouseX,
                py: pmouseY,
            });
            p.line(p.mouseX, p.mouseY, p.pmouseX, p.pmouseY);
        }
    };

    p.mousePressed = function (event) {
        console.log(event);
    }

    p.mouseReleased = function () {
        // Ensure canvas.elt is accessible before using it
        isDrawingLine = false;
        if (canvas && canvas.elt) {
            //const dataURL = canvas.elt.toDataURL();
            //image.current = dataURL;
            //socket.emit('send-image', dataURL);
        }
    };

    p.mouseDragged = function () {
        const { mouseX, mouseY, pmouseX, pmouseY } = p;
        socket.emit('drawing', {
            x: mouseX,
            y: mouseY,
            px: pmouseX,
            py: pmouseY,
        });
    };

    p.saveState = () => {
        if (undoStack.length >= MAX_UNDO) {
            undoStack.shift();
        }
        let img = p.get();
        undoStack.push(img);
    };

    p.undo = () => {
        if (undoStack.length > 0) {
            let previousState = undoStack.pop();
            p.clear();
            p.background(255); // Ensure background is reset if needed
            p.image(previousState, 0, 0);
        } else {
            console.log('No more actions to undo.');
        }
    };

    function arrayEquals(a, b) {
        return (
            Array.isArray(a) &&
            Array.isArray(b) &&
            a.length === b.length &&
            a.every((val, index) => val === b[index])
        );
    }

    function expandToNeighbours(queue, current) {

        let x = current.x
        let y = current.y

        if (x - 1 > 0) {
            queue.push({ x: x - 1, y: y });
        }

        if (x + 1 < p5width) {
            queue.push({ x: x + 1, y: y });
        }

        if (y - 1 > 0) {
            queue.push({ x: x, y: y - 1 });
        }

        if (y + 1 < p5height) {
            queue.push({ x: x, y: y + 1 })
        }

        return queue;
    }

    function floodFill(seed, fillColorHex) {
        let fillColor = hexToRGB(fillColorHex, 255);
        console.log(fillColor);
        p.loadPixels();

        let index = 4 * (p5width * seed.y + seed.x);
        let seedColor = [
            p.pixels[index],
            p.pixels[index + 1],
            p.pixels[index + 2],
            p.pixels[index + 3],
        ];

        let queue = [];
        queue.push(seed);
        let loopCount = 0;

        while (queue.length) {
            let current = queue.shift();
            index = 4 * (p5width * current.y + current.x);
            let color = [
                p.pixels[index],
                p.pixels[index + 1],
                p.pixels[index + 2],
                p.pixels[index + 3],
            ];

            if (!arrayEquals(color, seedColor)) {
                continue;
            }


            p.pixels[index] = fillColor[0];
            p.pixels[index + 1] = fillColor[1];
            p.pixels[index + 2] = fillColor[2];
            p.pixels[index + 3] = fillColor[3];


            loopCount++;
            if (loopCount > 50000) break;

            expandToNeighbours(queue, current)
        }

        p.updatePixels()

    }

    function hexToRGB(hex, alpha) {
        var r = parseInt(hex.slice(1, 3), 16),
            g = parseInt(hex.slice(3, 5), 16),
            b = parseInt(hex.slice(5, 7), 16);
        return [r, g, b, alpha];
    }

}

function DrawingCanvas() {
    const socket = useContext(SocketContext);
    const fillBtn = useRef(null);

    //useEffect(() => {
    //}, []);

    function handleColorChange(newValue) {
        socket.emit('sc', { color: newValue });
        color = newValue;
    }

    function handleWeightChange(newValue) {
        socket.emit('setweight', { weight: newValue });
        strokeWeight = newValue;
    }

    function handleClear() {
        if (p5) {
            socket.emit('clear');
            p5.background(255);
        }
    }

    function switchToFill() {
        const fill = fillBtn.current;
        //toggle fill mode and set the correct cursor for the mode.
        if (p5) {
            inFillMode = !inFillMode;
            
            if (inFillMode) {
                //set the button with id fillbtn text to "fill" and set the cursor to crosshair
                fill.textContent = "Switch to draw";
                p5.cursor(p5.CROSS);
            }
            else {
                fill.textContent = "Switch to fill";
                p5.cursor(p5.ARROW);
            }
        }
    }

    return <div>
        <ReactP5Wrapper sketch={(p) => sketch(p, socket)} />
        <ColorInput onColorChanged={handleColorChange} onWeightChanged={handleWeightChange} />
        <StyleSelector />
        <button onClick={handleClear}>Clear</button>
        <button ref={fillBtn} onClick={switchToFill}>Switch to fill</button>
    </div>;
}

export default DrawingCanvas;